<div [ngSwitch]="mode">
	<app-login *ngSwitchCase="'Login'"></app-login>
	<app-main-layout *ngSwitchCase="'Portal'"></app-main-layout>
</div>
